import React, { useCallback, useEffect, useState } from "react";
import Page from "../../Components/Page";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import FetchHook from "../../Api/FetchHooks";
import moment from "moment";
import AlertComponent from "../../Components/AlertComponent";
import TableComponent from "../../Components/TableComponent";
import { AllInbox } from "@mui/icons-material";
import DateRangePicker from "../../Components/DateRangePicker";
import { formatDate } from "../../utils/helpers";

const ExtendedSavingsReport = () => {
  const location = useLocation();
  const loggedInUser = useSelector((state) => state?.auth?.user);

  const [startDate, setStartDate] = useState(new Date("2025-01-01"));
  const [endDate, setEndDate] = useState(new Date());
  const [status, setStatus] = useState("");

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const [user, setUser] = useState(location?.state?.user || loggedInUser);
  const [data, setData] = useState([]);

  const [loading, response, request] = FetchHook();

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchData = useCallback(async () => {
    try {
      const start = moment(startDate).format("YYYY-MM-DD");
      const end = moment(endDate).format("YYYY-MM-DD");
      await request({
        url: `/saving_extended_report?status=${status}&start_date='${start}'&end_date='${end}'`,
      });
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  }, [status, request, startDate, endDate]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    if (response && response.status === 200 && response.data.StatusCode === 0) {
      setData(response.data.Report);
    }
  }, [response]);

  const columns = [
    {
      field: "entity_id",
      headerName: "Entity Id",
      width: 150,
    },
    {
      field: "msisdn",
      headerName: "Msisdn",
      width: 150,
    },
    {
      field: "fullname",
      headerName: "Full Name",
      width: 150,
    },
    {
      field: "channel_name",
      headerName: "Channel",
      width: 150,
    },
    {
      field: "actual_saving",
      headerName: "Actual saving",
      width: 150,
    },
    {
      field: "actual_saving",
      headerName: "Actual saving",
      width: 150,
    },
    {
      field: "created_on",
      headerName: "Created On",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "last_updated_on",
      headerName: "Last Updated On",
      width: 200,
      valueFormatter: (params) => formatDate(params?.value),
    },
  ];

  console.log("response", response);

  return (
    <Page title={"Extended Savings Report"}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          action={
            <Box sx={{ my: 2, display: "flex", gap: 2 }}>
              <FormControl sx={{ width: "150px" }}>
                <InputLabel id="status" size="small">
                  Status
                </InputLabel>

                <Select
                  labelId="loan_status"
                  id="loan_status"
                  value={status}
                  label="status"
                  onChange={(e) => {
                    setStatus(e.target.value);
                  }}
                  size="small"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="domant">Dormant</MenuItem>
                  <MenuItem value="suspended">Suspended</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                  <MenuItem value="incomplete">Incomplete</MenuItem>
                  <MenuItem value="complete">Complete</MenuItem>
                </Select>
              </FormControl>

              <DateRangePicker
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={setStartDate}
                onEndDateChange={setEndDate}
                onSearch={fetchData}
                loading={loading}
              />
            </Box>
          }
        />
        <CardContent>
          {data && data.length > 0 ? (
            <TableComponent data={data} columns={columns} loading={loading} />
          ) : data && data.length <= 0 && loading ? (
            <Grid display={"flex"} justifyContent={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <Grid
              container
              display={"flex"}
              direction={"column"}
              alignContent={"center"}
              justifyContent={"center"}
            >
              <AllInbox color="error" sx={{ mx: "auto", fontSize: 80 }} />
              <Typography>No Data</Typography>
            </Grid>
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default ExtendedSavingsReport;
